import { Maybe } from 'gql/graphql';

export const getTranslators = (translatorOne?: Maybe<string>, translatorsTwo?: Maybe<string>) =>
  translatorOne && translatorsTwo
    ? `${translatorOne}, ${translatorsTwo}`
    : (translatorOne || translatorsTwo) ?? '';
